import * as Const from "./../../../../framework/const.shared";
import * as Enums from "./../../../../framework/enum.shared";

import { ExceptionManager } from "../../../../framework/utils/exception-manager";
import { IIdentity } from "./../../../../framework/interface.shared";
import { Identity } from "../../../../shared/user/identity";
import { ProposalEntity } from "../proposal-entity.model";
import { IdentityRolesService } from "./../../../../services/identity-roles.service";
import { Component, Injectable } from "@angular/core";
import { AbstractProductFactory } from "../../abstract-factory/factory/abstract-product-factory";
import { ProductService } from "src/app/services/new-product/base/product.service";

@Injectable({
  providedIn: "root",
})
/** Service to track user current proposal activity */
export class ProposalEditableHelperService {
  constructor(
    public identityRolesService: IdentityRolesService,
    public productService: ProductService
  ) {}

  isReadOnly(proposal: ProposalEntity): boolean {
    /** Current login user is transaction read only user
     * It could be [Claims] or whatever read only user type
     */
    if (
      this.identityRolesService.getIdentity().isProposalTransactionReadOnly ===
      true
    ) {
      return true;
    }

    switch (proposal.proposalStatus) {
      case Enums.ProposalStatus.Renewed:
      case Enums.ProposalStatus.Endorsed:
      case Enums.ProposalStatus.Cancelled:
      case Enums.ProposalStatus.Accepted:
        // always read only
        return true;

      case Enums.ProposalStatus.Referred:
        return this.referred(proposal);

      // draft
      case Enums.ProposalStatus.None:
      case Enums.ProposalStatus.Incomplete:
        return this.incomplete(proposal);
      //DBSEP-2136
      case Enums.ProposalStatus.Declined:
        return this.declined(proposal);
      case Enums.ProposalStatus.PendingChecker:
        // always read only
        return true;

      case Enums.ProposalStatus.Approved:
        var result = this.approved(proposal);
        if (!result) {
          ExceptionManager.error("Not to be expected to in [Approved] status");
        }
        return result;
    }

    // default to true for unhandled case
    return true;
  }

  private approved(proposal: ProposalEntity): boolean {
    let productFactory!: AbstractProductFactory;
    productFactory = this.productService.getProductFactoryByProductId(
      proposal!.productId!
    );
    return productFactory.proposal().IsApprovedReadOnly(proposal);
  }

  private declined(proposal: ProposalEntity): boolean {
    switch (this.identityRolesService.getIdentity().currentUser().userType) {
      // only Non-operational Underwriter is able to view the declined button for IBG prodcut.
      case Enums.UserType.Underwriter:
        if (
          this.identityRolesService.getIdentity().role.isOperationUnderwriter &&
          (proposal.productId?.toString().toUpperCase() ===
            Const.ProductID.PRODUCT_ID_DBS_MF_IBG ||
            proposal.productId?.toString().toUpperCase() ===
              Const.ProductID.PRODUCT_ID_DBS_MACH_IBG)
        ) {
          return false;
        } else {
          return true;
        }
      default:
        return true;
    }
  }
  private referred(proposal: ProposalEntity): boolean {
    switch (this.identityRolesService.getIdentity().currentUser().userType) {
      // only Non-operational Underwriter is editable in referred mode
      case Enums.UserType.Underwriter:
        if (
          proposal.productId?.toString().toUpperCase() ===
            Const.ProductID.PRODUCT_ID_DBS_MF_IBG ||
          proposal.productId?.toString().toUpperCase() ===
            Const.ProductID.PRODUCT_ID_DBS_MACH_IBG
        ) {
          return true;
        } else {
          return false;
        }
      default:
        return true;
    }
  }

  private incomplete(proposal: ProposalEntity): boolean {
    let productFactory!: AbstractProductFactory;
    productFactory = this.productService.getProductFactoryByProductId(
      proposal!.productId!
    );
    return productFactory
      .proposal()
      .IsIncompleteReadOnly(this.identityRolesService);
  }
}
